import { ArrowRight } from "lucide-react";
import { FadeUp, Chapter } from "@/components/Reveal";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-28 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Chapter num="01" label="About" />
            <FadeUp delay={0.1}>
              <h2 className="mt-8 font-serif text-4xl leading-tight tracking-[-0.02em] text-cream sm:text-5xl">
                Marketing Built Around{" "}
                <span className="italic text-gold">Results.</span>
              </h2>
            </FadeUp>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <FadeUp delay={0.2} className="space-y-6 text-base leading-relaxed text-cream/60 md:text-lg">
              <p>
                MK Group Plus LLC is a modern digital marketing agency focused
                on helping businesses grow through strategy, creativity, and
                measurable results.
              </p>
              <p>
                We combine branding, social media, paid advertising, SEO, and
                content creation into tailored marketing solutions designed for
                long-term growth.
              </p>
              <p className="border-l-2 border-gold/50 pl-6 font-serif text-xl italic text-cream/80 md:text-2xl">
                Even though we're a growing agency, our mission is simple:
                deliver quality work, honest communication, and real business
                results.
              </p>
            </FadeUp>
            <FadeUp delay={0.3}>
              <a
                href="/#services"
                data-testid="about-learn-more-btn"
                className="group mt-10 inline-flex items-center gap-2 text-sm font-semibold tracking-wide text-gold"
              >
                Learn More
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
              </a>
            </FadeUp>
          </div>
        </div>
      </div>
    </section>
  );
}
